<template>
  <div class="cal-page">
    <div class="white-section mt-2" >
    <div class="bg-search">
      <div class="advanceSearch-card" id="advanceSearchCard" v-click-outside="closeAdvanceSearch">
        <button @click="showadvanceSearch()" class="btn btn-success searchBtn">
        <feather-icon
        size="17"
        icon="SearchIcon"
        style="margin-left: 5px;"
      />
     جستجوی پیشرفته
      </button>
      <b-col  class="advanceSearch mb-1">
        <b-row class="d-flex align-items-center flex-nowrap">
          <b-col xl="3" md="3" cols="12" sm="12" class="mb-md-0" style="margin-top:-9px">
            <label for="name" style="margin-top: 9px">نام دکتر</label>
            <b-form-input
              v-model="searchName"
              type="text"
              class="d-inline-block"
              id="name"
              @keypress.enter="searchAdvance()"
            />
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="3">
            <b-form-group
              :label="$t('user.medicalSpecialtyId')"
              class="mb-0"
            >
              <my-v-select
                :key="medicalSpecialtyId"
                id="user-speciality"
                :translate="false"
                v-model="medicalSpecialtyId"
                :concat-label="['title']"
                :options="medicalSpecialties"
                :multiple="false"
                :searchable="true"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="3">
            <b-form-group
              :label="$t('user.unit')"
              class="mb-0"
            >
              <my-v-select
                :key="unit"
                :options="units"
                v-model="unit"
                custom-class="w-100 mr-2"
                :concat-label="['title']"
              />
            </b-form-group>
          </b-col>

              <v-btn
            tag="button"
            class="btn btn-success"
            style="margin-top: 21px;"
            @click="searchAdvance()"
            id="searchButton"
            >{{ $t("general.search") }}
          </v-btn>
        </b-row>
        <Plan
        :doctorIdSelected="doctorIdSelected"
        :doctorName="doctorName"
        @close="close"
        :advancedSearch="advancedSearch"
        v-if="modalShow"
      />
      </b-col>
        <b-col class="user-result">
        <div class="users-table">
        <vue-good-table
          v-if="advancedSearch && advancedSearch.length>0"
          :columns="columns"
          :rows="advancedSearch"
        >
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label === 'action'" class="text-nowrap">
              {{ $t("general.action") }}
            </span>
          </template>

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'firstName'" class="text-nowrap">
              <span>{{ props.row.firstName }} </span>
            </span>
            <span v-if="props.column.field === 'lastName'" class="text-nowrap">
              <span>{{ props.row.lastName }} </span>
            </span>
            <span v-else-if="props.column.field === 'medicalSpecialtyId'" class="d-flex">
             <span v-if="props.row.medicalSpecialtyId">{{ props.row.medicalSpecialtyId.title }}</span>
             <span v-else>-</span>
            </span>
            <span v-else-if="props.column.field === 'units'" class="d-flex">
              <span
                  v-for="(unit, index) in props.row.units"
                  :key="'unit_' + index"
                  >{{ unit.title }}
                  <template v-if="index !== props.row.units.length - 1">
                    -
                  </template></span
                >
            </span>
            <span v-if="props.column.field === 'action'">
              <span>
                <button
                  class="btn btn-primary btn-sm mr-1"
                  @click="
                    $bvModal.show('modal-scoped');
                    getDoctorIdselected(props.row);
                  "
                >
                  {{ $t("general.planOfDoctor") }}
                </button>
                <button
                  class="btn btn-success btn-sm mr-1"
                  @click="handleDoctorSelection(props.row)"
                >
                 نوبت دهی
                </button>
              </span>
            </span>
          </template>
        </vue-good-table>
        <div v-if="emtResult" class="mt-1 emtResult">موردی یافت نشد!</div>
      </div>

      </b-col>
     </div>
    </div>
      <b-col>
        <b-row style="height:90px ">
          <b-col style="height:90px;padding: 2px 12px;">
            <b-row style="height:90px">
                <b-col style="height:90px;padding: 2px 12px;">
                  <b-form-group v-if="users && users.length > 0" label="پزشک را انتخاب کنید" label-for="doctorSelect1">
                    <v-app id="doctorSelect">
                      <v-autocomplete
                      id="doctorSelect1"
                        :items="users"
                        v-model="selectDoctor"
                        density="doctorSelect1"
                        item-value="_id"
                        item-title="username"
                        item-text="username"
                        :filter="filterData"
                        filled
                        rounded
                        hide-details
                        :menu-props="{ auto: false }"
                        @keyup="handleKeyup"
                      >
                      <template v-slot:prepend-item v-if=" recentSearches.length !=0 && recently">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold firstSecTitle"> <span> جستجوهای اخیر </span> </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <div v-for="searchItem in recentSearches.slice(0, 4)" :key="searchItem._id">
                          <v-list-item @click="selectRecentSearch(searchItem)" style="height:38px">
                            <div>
                              <img :src="searchItem.avatar" class="avatar-user">
                            </div>
                            <v-list-item-content>
                              <v-list-item-title>{{ searchItem.firstName }} {{ searchItem.lastName }} </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                        <v-divider class=""></v-divider>
                      </template>
                      <template v-slot:selection="data">
                        <div class="d-flex align-items-center " style="height:36px">
                          <img :src="data.item.avatar" class="avatar-user">
                          {{ data.item.firstName + " " + data.item.lastName }}
                        </div>
                      </template>
                      <template v-slot:item="data">
                        <div class="d-flex align-items-center">
                          <img :src="data.item.avatar" class="avatar-user" >
                          {{ data.item.firstName + " " + data.item.lastName }}
                        </div>
                      </template>
                      </v-autocomplete>
                    </v-app>
                  </b-form-group>
                </b-col>
                <b-col style="height:90px;padding: 2px 12px;">
                  <b-form-group v-if="unitOption && unitOption.length > 0" label="واحد را انتخاب کنید" label-for="unitSelectedId">
                    <my-v-select
                      v-if="unitOption && unitOption.length > 0"
                      :key="unitSelectedId"
                      id="unitSelectedId"
                      v-model="unitSelectedId"
                      :clearable="false"
                      :multiple="false"
                      :options="unitOption.length ? unitOption : []"
                      :translate="false"
                      :searchable="true"
                      :filterable="true"
                    />
                  </b-form-group>
                </b-col>
            </b-row>
          </b-col>
          <b-col>
            <div class="btn-week" v-if="showCalendar && !noPlan && !ShowQueueList && showListCalendars">
                <my-ab-date-picker
                  :ref="selectedDate ? selectedDate.toString() : 'selected-date'"
                  :type="'date'"
                  :locale="'fa,en'"
                  click-on="all"
                  :clearable="false"
                  :show="false"
                  :auto-submit="true"
                  :column="1"
                  v-model="selectedDate"
                  :toIso="true"
                  :custom-hour="23"
                  id="selected-date"
                  class="todayBtn"
                  @input="DateSelectDate"
                  :disabled="editMode">
                </my-ab-date-picker>
                <button class="prevWeekBtn" @click="prevWeek"><feather-icon icon="ChevronLeftIcon"  size="12"/> هفته قبل </button>  
                <button class="todayBtn" @click="goToToday"> هفته جاری </button> 
                <button class="nextWeekBtn" @click="nextWeek">هفته بعد <feather-icon icon="ChevronRightIcon"  size="12"/></button> 
            </div>
            <div v-if="!showCalendar && noPlan && !ShowQueueList">
              <div class="topMenuCal">
                <div class="actionCal"></div>
                <div class="btn-week">
                  <my-ab-date-picker
                    :ref="selectedDate ? selectedDate.toString() : 'selected-date'"
                    :type="'date'"
                    :locale="'fa,en'"
                    click-on="all"
                    :clearbleStatus="false"
                    :show="false"
                    :auto-submit="true"
                    :column="1"
                    v-model="selectedDate"
                    :toIso="true"
                    :custom-hour="23"
                    id="selected-date"
                    class="todayBtn"
                    @input="DateSelectDate"
                    :disabled="editMode">
                  </my-ab-date-picker>
                  <button class="prevWeekBtn" @click="prevWeek"><feather-icon icon="ChevronLeftIcon"  size="14"/> هفته قبل </button>  
                  <button class="todayBtn" @click="goToToday"> هفته جاری </button> 
                  <button class="nextWeekBtn" @click="nextWeek">هفته بعد <feather-icon icon="ChevronRightIcon"  size="14"/></button> 
                </div> 
              </div>
              <div v-if="!showCalendar && noPlan && !showActionBtn && detailPlans && detailPlans.length !=0" style="height:25px;margin-top:10px;text-align:left;float:left;padding-left:18px;">
                <p v-if="detailPlans && detailPlans.length !=0">برای این پزشک از تاریخ <strong>{{ dateToPersian(detailPlans.fromDate) }}</strong>  تا  <strong>{{ dateToPersian(detailPlans.endDate) }}</strong> برنامه ثبت شده است.</p>
              </div>
              <!-- <p style="margin: 15px; font-weight: bold;">متاسفانه برنامه ای برای این پزشک در این بازه تاریخی مشخص نشده است، لطفا بازه تاریخی دیگری را امتحان کنید</p> -->
            </div>
            <div v-if="!showListCalendars && ShowQueueList && startDate" class="d-flex align-items-center justify-content-end" style="margin-top:6px">
                  <my-ab-date-picker
                    v-if="startDate"
                    :ref="startDate ? startDate.toString() : 'start-date'"
                    :type="'date'"
                    :locale="'fa,en'"
                    :format="`YYYY-MM-DD`"
                    click-on="all"
                    clearable
                    :show="false"
                    :auto-submit="true"
                    :column="1"
                    v-model="startDate"
                    :initialVal="todayCal"
                    :toIso="true"
                    :custom-hour="23"
                    id="start-date"
                    class="todayBtn"
                    @input="generateDate"
                  >
                  </my-ab-date-picker>
                <div class="d-flex justify-content-end" v-if="ShowQueueList">
                  <div class="btn-group option" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-warning" style="margin-left:5px" @click="showMessage = !showMessage">ارسال پیامک گروهی</button>
                    <button type="button" class="btn btn-success" @click="showMove = !showMove">جابجایی</button>
                  </div>
                </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <div v-if="showCalendar && !noPlan &&  unitSelectedId != null">
        <div class="d-flex justify-content-start">
          <button :class="{ bgChangeActive : showListCalendars }" type="button" class="btn bgButton bgButton2" @click="showListCalendar">هفته</button>
          <button :class="{ bgChangeActive : ShowQueueList }" type="button" class="btn bgButton bgButton1" @click="ShowQueueLists">نمایش لیست</button>
        <!-- <b-form-group  v-if="ShowQueueList">
          <my-ab-date-picker
            :ref="startDate ? startDate.toString() : 'start-date'"
            :type="'date'"
            :locale="'fa,en'"
            click-on="all"
            clearable
            :show="false"
            :auto-submit="true"
            :column="1"
            v-model="startDate"
            :toIso="true"
            :custom-hour="23"
            id="start-date"
            @input="generateDate"
          >
          </my-ab-date-picker>
        </b-form-group> -->
        </div>
        
        <!-- <div class="d-flex justify-content-end mt-2" v-if="ShowQueueList">
          <div class="btn-group option" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-warning" @click="showMessage = !showMessage">ارسال پیامک گروهی</button>
          <button type="button" class="btn btn-success" @click="showMove = !showMove">جابجایی</button>
        </div>
        </div> -->
        <!-- مدال ارسال پیامک -->
        <div class="modalsendMessage" v-if="showMessage" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel"> ارسال گروهی پیامک</h5>
              <button type="button" class="close" @click="closeShowMsg">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                  <label for="exampleFormControlTextarea1">متن پیامک</label>
                  <textarea class="form-control" id="exampleFormControlTextarea1"></textarea>
                  <small class="text">متن پیامک جهت ارسال به مخاطبان انتخاب شده</small>
                </div>
                <vue-good-table
                  :columns="list"
                  :rows="listSelect"
                >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field === 'change'" class="text-nowrap">
                        <span><input type="checkbox"></span>
                      </span>
                      <span v-if="props.column.field === 'fullName'" class="text-nowrap">
                        {{props.row.turnUserId.firstName}}  {{props.row.turnUserId.lastName}} 
                      </span>
                      <span v-else-if="props.column.field === 'mobile'" class="d-flex">
                      {{ props.row.turnUserId.mobile }}
                      </span>
                    </template>
                </vue-good-table>
              </div>
              <div class="modal-footer">
                <div class="btn-group option" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-light" @click="closeShowMsg">
                    انصراف
                  </button>
                  <button type="button" class="btn btn-success">
                    ذخیره
                  </button>
                </div>
              </div>
                </div>
              </div>
            </div>
            <!-- مدال جابجایی -->
            <div class="modalShowMove" v-if="showMove" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">جابه جایی گروهی نوبت ها</h5>
              <button type="button" class="close" @click="closeShowMove">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                  <label for="exampleFormControlTextarea1">دلیل جا به جایی نوبت ها</label>
                  <textarea class="form-control" id="exampleFormControlTextarea1"></textarea>
                  <small class="text">این متن در پیامک اطلاع رسانی تغییر نوبت به عنوان دلیل تغییر نوبت برای بیماران ارسال خواهد شد.</small>
                </div>
                <div class="transfer-list">
                  <label>انتقال به:</label>
                  <my-ab-date-picker
                  :type="'date'"
                  :locale="'fa,en'"
                  click-on="all"
                  clearable
                  :show="false"
                  :auto-submit="true"
                  :column="1"
                  v-model="dateMove"
                  :toIso="true"
                  :custom-hour="23"
                  id="start-date11"
                  class="mb-1"
                  style="margin-top:5px"
                  >
                  </my-ab-date-picker>
                  <date-picker
                      mode="single"
                      type="time"
                      modal
                      :jump-minute="15"
                      :round-minute="true"
                      :auto-submit="false"
                      clearable
                    >
                    </date-picker>
                </div>
                <button class="btn btn-primary mb-2 d-block">تنظیمات پیشرفته</button>
                <button class="btn btn-success mb-1 d-block ml-auto">جستجوی زمان جدید </button>
                <div>
                  <label>لیست نوبت هایی که جا به جا خواهند شد:</label>
                  <vue-good-table
                  :columns="listMove"
                  :rows="listSelect"
                >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field === 'change'" class="text-nowrap">
                        <span><input type="checkbox"></span>
                      </span>
                      <span v-if="props.column.field === 'fullName'" class="text-nowrap">
                        {{props.row.turnUserId.firstName}} {{props.row.turnUserId.lastName}} 
                      </span>
                      <span v-if="props.column.field === 'date'" class="text-nowrap">
                        {{ dateToPersian(props.row.date) }}
                      </span>
                      <span v-if="props.column.field === 'fromTime'" class="text-nowrap">
                        {{props.row.fromTime}}
                      </span>
                    </template>
                </vue-good-table>
                </div>
              </div>
              <div class="modal-footer">
                <div class="notices d-flex align-items-center">
                  اطلاع رسانی از طریق: 
                  <div class=" d-flex align-items-center">
                    <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                    <label class="form-check-label" for="defaultCheck1">
                      پیامک
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck2">
                    <label class="form-check-label" for="defaultCheck2">
                     پست الکترونیکی
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck3">
                    <label class="form-check-label" for="defaultCheck3">
                     تلفنی
                    </label>
                  </div>
                  </div>
                </div>
                <div class="btn-group option" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-light" @click="closeShowMove">
                    انصراف
                  </button>
                  <button type="button" class="btn btn-success">
                    ذخیره
                  </button>
                </div>
              </div>
                </div>
              </div>
            </div>



        <div v-if="ShowQueueList" class="mt-3">
          <vue-good-table
          :columns="column"
          :rows="listResult"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'change'" class="text-nowrap">
              <span><input type="checkbox" :checked="isSelected(props.row)" @click="toggleCheckbox(props.row)"></span>
            </span>
            <span v-if="props.column.field === 'firstName'" class="text-nowrap">
              {{props.row.turnUserId.firstName}}
            </span>
            <span v-if="props.column.field === 'lastName'" class="text-nowrap">
              {{props.row.turnUserId.lastName}}
            </span>
            <span v-else-if="props.column.field === 'fromDate'" class="d-flex">
             {{ props.row.fromTime }}
            </span>
            <span v-else-if="props.column.field === 'endDate'" class="d-flex">
             {{ props.row.endTime }}
            </span>
            <span v-else-if="props.column.field === 'mobile'" class="d-flex">
             {{ props.row.turnUserId.mobile }}
            </span>
            <span v-else-if="props.column.field === 'status'" class="d-flex">
              <span
              v-if="props.row.isCome === false && props.row.isDeleted === false"
              class="badge badge-info"
              >نوبت گرفته شده</span>

              <span
              v-else-if="props.row.isDeleted === true && props.row.status === 'normal' || props.row.isDeleted === true && props.row.status === 'displacement_so_moved'"
              class="badge badge-danger"
              >
              حذف شده</span>

              <span
              v-else-if="props.row.isDeleted === true && props.row.status === 'moved' || props.row.isDeleted === true && props.row.status === 'displacement'"
              class="badge badge-warning"
              >
               انتقال داده شده</span>
            <span
              v-else-if="props.row.isCome === true"
              class="badge badge-success"
              >مراجعه شده</span>
            </span>
           
          </template>
        </vue-good-table>
         
        </div>
        <div v-if="showListCalendars && unitSelectedId != null">
          <div class="topMenuCal">
          <div class="actionCal"></div>
        </div>
        <div class="calendar-box mt-3" v-if="!isNotToShow">
          <div class="headerCal">
            <div class="headerTitle">
              <div class="titleCal">
                  ساعت / روز  
              </div>
            </div>
            
            <div class="dayTitle" v-if="weekDayArray && !isChangeDate">
              <div v-for="day,index in weekDayArray" :date-holiday="isHolidays[index]" :key="index" class="daysBox" :class="[{'today': day.dayTime == todayCal},{'holiday': isHolidays[index] == true }]">
                <span
                v-if="index+1 == 1"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)" 
                style="width: 100%;height: 100%;"
              >
                شنبه ({{ day.dayTime }}<p v-if="day.dayTime == todayCal">- امروز</p>)
              </span>
              <span
                v-if=" index+1 == 2"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)" 
                style="width: 100%;height: 100%;"
              >
              یکشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == todayCal">-  امروز</p> ) 
                 </span>
                 <span
                v-if=" index+1 == 3"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)" 
                style="width: 100%;height: 100%;"
              >
              دوشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == todayCal">-  امروز</p>)
               </span>
               <span
                v-if="index+1 == 4"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)" 
                style="width: 100%;height: 100%;"
              >
              سه شنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == todayCal">-  امروز</p> )
               </span>
               <span
                v-if="index+1 == 5"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)"
                style="width: 100%;height: 100%;" 
              >
              چهارشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == todayCal">-  امروز</p> )
               </span>
               <span
                v-if="index+1 == 6"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)" 
                style="width: 100%;height: 100%;"
              >
              پنج شنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == todayCal">-  امروز</p> ) 
                </span>
                <span
                v-if="index+1 == 7"
                ref="dayElement"  
                class="tooltip-trigger"
                @mouseover="showTooltip(index)" 
                @mouseleave="hideTooltip(index)" 
                style="width: 100%;height: 100%;"
              >
              جمعه ( {{ day.dayTime }}<p v-if=" day.dayTime == todayCal">-  امروز</p> )  
                </span>
              </div>
            </div>
            <div class="dayTitle" v-if="weekDayArray && isChangeDate && currentCal != todayCal">
              <div v-for="day,index in weekDayArray" :key="index" class="daysBox" :class="[{'currentDay': day.dayTime == todayCal},{'holiday': isHolidays[index] == true }]">
                <span v-if=" index+1 == 1"> شنبه  ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p> ) </span>
                <span v-if=" index+1 == 2"> یکشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p> ) </span>
                <span v-if=" index+1 == 3"> دوشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p>) </span>
                <span v-if=" index+1 == 4"> سه شنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p> ) </span>
                <span v-if=" index+1 == 5"> چهارشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p> ) </span>
                <span v-if=" index+1 == 6"> پنج شنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p> ) </span>
                <span v-if=" index+1 == 7"> جمعه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal"></p> ) </span>
              </div>
            </div>
            <div class="dayTitle" v-if="weekDayArray && isChangeDate && currentCal == todayCal">
              <div v-for="day,index in weekDayArray" :key="index" class="daysBox" :class="{'today': day.dayTime == currentCal}">
                <span v-if=" index+1 == 1"> شنبه  ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p> ) </span>
                <span v-if=" index+1 == 2"> یکشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p> ) </span>
                <span v-if=" index+1 == 3"> دوشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p>) </span>
                <span v-if=" index+1 == 4"> سه شنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p> ) </span>
                <span v-if=" index+1 == 5"> چهارشنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p> ) </span>
                <span v-if=" index+1 == 6"> پنج شنبه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p> ) </span>
                <span v-if=" index+1 == 7"> جمعه ( {{ day.dayTime }}<p v-if=" day.dayTime == currentCal">-  امروز</p> ) </span>
              </div>
            </div>
          </div>
          <div class="bodyCal">
            <div class="timeSheet">
              <div v-for="time,index in allHours" :key="index" class="timeBox">
                  <div class="sheet"> {{ index + startHour }}</div>
              </div>
            </div>
              <div class="weekDayTime" v-if="weekDayArray && timeArray">
                <div v-for="day , index in weekDayArray" :key="index" class="daysBox" :class="{'holiday': isHolidays[index] == true }">
                  <div class="plan" v-for="time,indexT in timeArray.slice((index*dayParts),((index+1)*dayParts))" :key="indexT" :class="{'isBorderT': time.oldTimeId == time.timeId}" :data-oldId="time.oldTimeId" :data-tId="time.timeId" :data-startTime="time.time" >
                    <div class="hasTime" v-if="time.maxTurn >= 1" :class="{'holiday' : time.isHoliday == true}">
                      <div class="hasTurn" v-if="time.hasTurn.length != 0 && time.hasTurn.filter(n => n.isDeleted == false).length != 0" >
                        <draggable ref="myDrag" tag="ul" class="trun-box" :class="time.isHoliday ? 'c-error' : 'c-pointer' " v-bind="dragOptions" :list="time.hasTurn" @end="onEnd" :move="onMove" @dragstart="isDragging=true" @click="eventClick(time,null,index,time.isPast,time.isHoliday,time.isToday)">
                          <li v-for="turn in time.hasTurn.filter(n => n.isDeleted == false)" :key="turn._id" class="isTime boxTime" :data-holiday="`${time.isHoliday}`" :data-isToday="`${time.isToday}`" :data-past="`${time.isPast}`" :data-time="time.time" :data-turns="time.turnCount" :data-date="time.date" :data-maxTurn="time.maxTurn" :data-turnId="turn._id" :data-timeId="time.items.time._id" :data-oldId="time.oldTimeId" :data-planId="time.items.planDetail._id">
                              <div class="trun-box-el" v-if="!turn.isDeleted" @click="eventClick(time,turn,index,time.isPast,time.isHoliday,time.isToday)" @dragend="dragEnd(turn , time ,index, indexT)" draggable="true">                             
                                <span ref="myTurn">
                                  {{time.items.time.fromTime}}
                                </span>
                                <feather-icon size="10" icon="MenuIcon"/> 
                              </div>
                            </li>
                        </draggable>
                      </div>
                      <div v-else style="width:100%" @click="eventClick(time,null,index,time.isPast,time.isHoliday,time.isToday)">
                        <div style="height:20.3px">     
                          <draggable style="width:100%;height:100%" tag="div" v-model="time.hasTurn" v-bind="dragOptions" @click="eventClick(time,null,index,time.isPast,time.isHoliday,time.isToday)">
                             <ul style="width:100%;height:100%" class="ulClass" :class="time.isHoliday ? 'c-error' : 'c-pointer' " :data-time="time.time" :data-turns="time.turnCount" :data-holiday="`${time.isHoliday}`" :data-isToday="`${time.isToday}`" :data-past="`${time.isPast}`" :data-date="time.date" :data-maxTurn="time.maxTurn" :data-turnId="0" :data-timeId="time.items.time._id" :data-oldId="time.oldTimeId" :data-planId="time.items.planDetail._id"></ul>   
                          </draggable>
                        </div>
                      </div>
                    </div>
                    <div class="noTime c-error" v-if="!time.maxTurn || time.maxTurn == 0" :class="{'holiday' : time.isHoliday == true}">
                      <div style="height:20.3px">
                        <draggable style="width:100%;height:100%" tag="div" v-model="time.hasTurn" v-bind="dragOptions">
                             <ul style="width:100%;height:100%" class="ulClass" :data-time="time.time" :data-date="time.date" :data-holiday="`${time.isHoliday}`" :data-isToday="`${time.isToday}`" :data-past="'false'" :data-turns="time.turnCount" :data-maxTurn="time.maxTurn" :data-turnId="0" :data-timeId="0" :data-planId="0"></ul>   
                        </draggable>
                      </div>
                    </div>                  
                  </div>
                </div>
              </div>        
          </div>  
        </div>
        <div v-else>
          <!-- <p style="margin: 15px; font-weight: bold;">متاسفانه برنامه ای برای این پزشک در این بازه تاریخی مشخص نشده است، لطفا بازه تاریخی دیگری را امتحان کنید</p> -->
        </div>
          <div id="tooltip-content"  ref="tooltipContent" style="display: none;">
              <table>
                <thead>
                  <tr>
                    <th>ساعت پذیرش</th>
                    <th>نوبت مجاز</th>
                    <th>نوبت گرفته شده</th>
                    <th style="color:#15b7ae">نوبت آزاد</th>
                  </tr>
                </thead>
                <tbody v-if="checkIndex === 0">
                  <tr  v-for="saturday in detailPlans.saturdays" :key="saturday.id">
                  <td>{{ saturday.fromTime }} {{ saturday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
                <tbody v-if="checkIndex === 1">
                  <tr  v-for="sunday in detailPlans.sundays" :key="sunday.id">
                  <td>{{ sunday.fromTime }} {{ sunday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
                <tbody v-if="checkIndex === 2">
                  <tr  v-for="monday in detailPlans.mondays" :key="monday.id">
                  <td>{{ monday.fromTime }} {{ monday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
                <tbody v-if="checkIndex === 3">
                  <tr  v-for="tuesday in detailPlans.tuesdays" :key="tuesday.id">
                  <td>{{ tuesday.fromTime }} {{ tuesday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
                <tbody v-if="checkIndex === 4">
                  <tr  v-for="wednesday in detailPlans.wednesdays" :key="wednesday.id">
                  <td>{{ wednesday.fromTime }} {{ wednesday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
                <tbody v-if="checkIndex === 5">
                  <tr  v-for="thursday in detailPlans.thursdays" :key="thursday.id">
                  <td>{{ thursday.fromTime }} {{ thursday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
                <tbody v-if="checkIndex === 6">
                  <tr  v-for="friday in detailPlans.fridays" :key="friday.id">
                  <td>{{ friday.fromTime }} {{ friday.endTime }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td style="color:#15b7ae">0</td>
                </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
      <div v-if="!showCalendar && isLoading" style="display:flex;flex-direction:row;justify-content: center;">
        <b-img
        style="height:150px"
              :src="loadingGif"
              alt="logo"
            />
      </div>
      <div class="modal modalDrag" tabindex="-1" v-if="showModalDrag">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">انتقال نوبت </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="closeModalDrag">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
          <!-- آیا از انتقال بیمار <span class="redColor">{{  trunInfo.turnUserId.firstName }} {{   trunInfo.turnUserId.lastName }}</span>, از تاریخ <span class="redColor">{{oldDate }}</span>  ساعت <span class="redColor">{{ dateOldTurn.time }}</span>
            به تاریخ <span class="redColor">{{ newDate }}</span>  ساعت <span class="redColor">{{ newTime }}</span>
          مطمئن هستید؟ -->

            <span>آیا از <b>انتقال</b> نوبت <span class="redColor">{{ trunInfo.turnUserId.firstName }} {{   trunInfo.turnUserId.lastName }}</span> <span v-if="trunInfo.turnUserId.nationalCode">با کد ملی <span  class="redColor">{{trunInfo.turnUserId.nationalCode}}</span></span></span>
          <table class="table table-bordered" style="margin-top:8px">
              <!-- <tr>
                <td>نام</td>
                <td class="redColor">{{ trunInfo.turnUserId.firstName }} {{   trunInfo.turnUserId.lastName }}</td>
              </tr> -->
              <tr>
                <td>تاریخ</td>
                <td class="redColor">
                  <span>{{oldDayName}} {{ oldDate }} </span>
                </td>
              </tr>
              <tr>
                <td>ساعت</td>
               <td class="redColor"> {{ dateOldTime  }}</td>                
              </tr>
            </table>
            <b> به </b>
            <table class="table table-bordered" style="margin-top:8px">
              <tr>
                <td>تاریخ</td>
                <td class="redColor">
                  {{dayNamed}} {{ newDate }} 
                </td>
              </tr>
              <tr>
                <td>ساعت</td>
               <td class="redColor"> {{ newTime  }}</td>                
              </tr>
            </table>
            <span> <b>مطمئن</b> هستید؟</span>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="closeModalDrag">خیر</button>
            <button type="button" class="btn btn-transfer" @click="dragEvt" >بله </button>
          </div>
        </div>
      </div>
    </div>
    </div>
    <Reserve
      v-if="reserveModal"
      :reserveDate="reserveDate"
      :reserveFromTime="reserveFromTime"
      :reserveEndTime="reserveEndTime"
      :planId="planId"
      :timeId="timeId"
      :turnOfTimePlanDetailId="turnOfTimePlanDetailId"
      :isComeStatus="isComeStatus"
      @closeM="closeM"
      @updateCal="updateCal"
      :turnUserId="turnUserId"
      @newReserveData="newReserveData"
      @removeReserveData="removeTrun"
      :doctorInfo="doctorInfo"
      :unitId="unitId"
      :keyDay="keyDay"
      :doctors="users"
      :past="currentPast"
      :holidays="holidaysList"
      :today="isToday"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import filterRoles from "@/mixins/filterRoles";
import draggable from 'vuedraggable'
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import flatPickr from "vue-flatpickr-component";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import Plan from "@/components/modal/CreateDoctorPlan.vue";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BBreadcrumb,
  BTooltip,
  BDropdown,
  BDropdownItem,
  BImg
} from "bootstrap-vue";
import Reserve from "@/components/modal/Reserve.vue";
import moment from "jalali-moment";
import dateFormat from "@/mixins/dateFormat";
import { VueGoodTable } from "vue-good-table";
import datePicker from "vue-persian-datetime-picker";

export default {
  mixins: [filterRoles , dateFormat],
  components: {
    BRow,
    BTooltip,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
    Reserve,
    draggable,
    BDropdown,
    BDropdownItem,
     MyAbDatePicker,
     BImg,
    flatPickr,
    MyVSelect,
    VueGoodTable,
    Plan,
    datePicker
  },
  validations() {},
  data() {
    return {
      doctorRoleId: "",
      selectDoctor: "",
      unitSelectedId: null,
      doctorInfo: {},
      unitId: "",
      users: [],
      plans: [],
      initial_events: [],
      showCalendar: false,
      planId: "",
      timeId: "",
      turnOfTimePlanDetailId: "",
      turnId: "",
      reserveModal: false,
      reserveDate: "",
      reserveFromTime: "",
      reserveEndTime: "",
      isComeStatus: false,
      turnUserId: "",
      daysInPlansFind: [],
      displacementPlanDetailsId: "",
      displacementTimeId: "",
      movePlanDetailsId: "",
      moveTimeId: "",
      moveTurnId: "",
      lockDatesArray: [],
      allowDates: [],
      rangeDates: [],
      notAllowDates: [],
      dayOfWeek: moment(new Date()).format("YYYY/MM/DD"),
      startDateOfWeek: null,
      endDateOfWeek: null,
      weekDayArray : [],
      timeArray : [],
      checkEl : null,
      dragList: null,
      dragBox : false,
      keyDay: null,
      editable: false,
      isDragging: false,
      delayedDragging: false,
      showListCalendars:true,
      ShowQueueList:false,
      startDate:null,
      dateOptions:[],
      showMessage:false,
      showMove:false,
      listSelect:[],
      dateMove:null,
      isToday: false,
      currentTime:{
        strat: null,
        end: null
      },
      showActionBtn: true,
      sourceEl: null,
      destEl: null,
      currentCal:null,
      dayParts: null,
      hoursShift:  null,
      allHours: null,
      startHour: null,
      planBArray : [],
      selectedDate: null,
      editMode: false,
      loadingGif : require('@/assets/images/loading.gif'),
      isLoading: false,
      isChangeDate: false,
      todayCal: null,
      noPlan: false,
      recentSearchItem: null,
      recentSearches: [],
      showList:true,
      searchName: "",
      advancedSearch:[],
      doctorIdSelected: "",
      doctorName: "",
      modalShow: false,
      MedicalSpecialtyTitle:'',
      emtResult:false,
      isMedicalSpecialtiesLoaded: false,
      isNotToShow: false,
      listResult:[],
      detailPlans:[],
      checkIndex:"",
      showModalDrag:false,
      trunInfo:"",
      dateOldTime:'',
      oldDate:"",
      newTime:'',
      newDate:'',
      dayNamed:"",
      oldDayName:"",
      unitOption: [],
      recently:true,
      currentPast : null,
      isHolidays: null,
      holidaysList: [],
      columns: [
      {
        label: "نام",
        field: "firstName",
      },
      {
        label: "نام خانوادگی",
        field: "lastName",
      },
      {
        label: "تخصص ",
        field: "medicalSpecialtyId",
      },
      {
        label: "واحد",
        field: "units",
      },
      {
        label: "عملیات",
        field: "action",
      }
        ],
        column:[
      {
        label: "انتخاب",
        field: "change",
      },
      {
        label: "نام",
        field: "firstName",
      },
      {
        label: "نام خانوادگی",
        field: "lastName",
      },
      {
        label: "زمان شروع ",
        field: "fromDate",
      },
      {
        label: "زمان پایان",
        field: "endDate",
      },
      {
        label: "شماره موبایل",
        field: "mobile",
      },
       {
        label: "وضعیت ",
        field: "status",
      }
        ],
        list:[
          {
        label: "انتخاب",
        field: "change",
      },
      {
        label: "نام و نام خانوادگی",
        field: "fullName",
      },
      {
        label: "شماره موبایل",
        field: "mobile",
      },
    ],
    listMove:[
      {
        label: "انتخاب",
        field: "change",
      },
      {
        label: "نام و نام خانوادگی",
        field: "fullName",
      },
      {
        label: "تاریخ",
        field: "date",
      },
      {
        label: "ساعت",
        field: "fromTime",
      },
    ]
    };
  },
  async created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "calendar", to: { name: "manageUsers" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "calendar", to: { name: "usersList" }, translate: true },
    ]);
    // this.searchUser(); 
    this.$store.dispatch("medicalSpecialties/getActiveMedicalSpecialty");
    this.$store.dispatch("units/searchUnit", {
      status:"active",
    });    
  },
  async mounted() {
    const today = new Date();
    this.currentCal = new Intl.DateTimeFormat('fa-IR').format(today);
    this.todayCal = new Intl.DateTimeFormat('fa-IR').format(today);
    this.searchUser()
    // this.$store.dispatch("getRoles").then((res) => {
    //   if (res) {
    //     this.doctorId = this.roleFilter = this.filterRoles("doctor");
    //     this.searchUser();
    //   }
    // });
    const storedSearches = localStorage.getItem("selectedDoctors");
    this.recentSearches = storedSearches ? JSON.parse(storedSearches) : [];

  },
  directives: {
    Ripple,
  },
  computed: {
    
    ...mapGetters({
      roles: "roles",
      units: "units/units",
      medicalSpecialties: "medicalSpecialties/medicalSpecialties",
    }),
    unit: {
      set(unit) {
        this.$store.commit("user/SET_UNIT", unit);
      },
      get() {
        return this.$store.getters["user/unit"];
      },
    },
    medicalSpecialtyId: {
      set(medicalSpecialtyId) {
        this.$store.commit("user/SET_MEDICAL_SPECIALTY_ID", medicalSpecialtyId);
      },
      get() {
        return this.$store.getters["user/medicalSpecialtyId"];
      },
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: this.editable,
        ghostClass: "ghost"
      };
    },
    // recentSearches: function() {
    //   return JSON.parse(localStorage.getItem("selectedDoctors") || "[]");
    // }
  },
  methods: {
    onEnd(){
      if(this.destEl && this.destEl.attributes['data-past'].value == "true" && this.sourceEl && this.sourceEl.attributes['data-past'].value == "true"){
         this.$bvToast.toast('مبدا و مقصد شما گذشته است', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
      else if(this.destEl && this.destEl.attributes['data-past'].value == "true" && this.sourceEl && this.sourceEl.attributes['data-past'].value == "false"){
         this.$bvToast.toast(' مقصد شما گذشته است', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
      else if(this.destEl && this.destEl.attributes['data-past'].value == "false" && this.sourceEl && this.sourceEl.attributes['data-past'].value == "true"){
         this.$bvToast.toast(' مبدا شما گذشته است', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
      else{
        if(this.destEl && this.destEl.attributes['data-maxTurn'].value == 0 && this.destEl.attributes['data-timeId'].value == 0 && this.destEl.attributes['data-planId'].value == 0){
          // this.$bvToast.toast('متاسفانه انتقال نوبت امکان پذیر نمی باشد', {
          //   title: this.$t("toastification.error"),
          //   variant: "danger",
          //   solid: true,
          // });
          this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
        }
      }

      // else if(this.destEl && this.destEl.attributes['data-turns'] && this.destEl.attributes['data-maxTurn'].value <= this.destEl.attributes['data-turns'].value) {
      //   this.$bvToast.toast('متاسفانه انتقال نوبت امکان پذیر نمی باشد', {
      //     title: this.$t("toastification.error"),
      //     variant: "danger",
      //     solid: true,
      //   });
      //   this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      // }
      this.isDragging = false
    },
    dragEnd(turn , time  , index , indexT ){
      if(this.destEl && this.destEl.attributes['data-past'].value == "true" && this.sourceEl && this.sourceEl.attributes['data-past'].value == "true"){
         this.$bvToast.toast('مبدا و مقصد شما گذشته است', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
      else if(this.destEl && this.destEl.attributes['data-past'].value == "true" && this.sourceEl && this.sourceEl.attributes['data-past'].value == "false"){
         this.$bvToast.toast(' مقصد شما گذشته است', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
      else if(this.destEl && this.destEl.attributes['data-past'].value == "false" && this.sourceEl && this.sourceEl.attributes['data-past'].value == "true"){
         this.$bvToast.toast(' مبدا شما گذشته است', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
      else{
        if(this.destEl && this.destEl.attributes['data-maxTurn'].value == 0 && this.destEl.attributes['data-timeId'].value == 0 && this.destEl.attributes['data-planId'].value == 0){
          this.$bvToast.toast('متاسفانه انتقال نوبت امکان پذیر نمی باشد', {
            title: this.$t("toastification.error"),
            variant: "danger",
            solid: true,
          });
          this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
        }
      else if(this.destEl && this.destEl.attributes['data-maxTurn'] && this.destEl.attributes['data-maxTurn'].value > 0 && this.destEl.attributes['data-turns'] && this.destEl.attributes['data-maxTurn'].value <= this.destEl.attributes['data-turns'].value) {
        this.$bvToast.toast('متاسفانه انتقال نوبت امکان پذیر نمی باشد', {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      }
        else{
          var newTimeArray = []
          newTimeArray = this.timeArray.slice((index*this.dayParts),((index+1)*this.dayParts))
          var detectItem = newTimeArray[indexT]
          this.trunInfo= turn
          if(this.sourceEl && this.destEl){
            this.dateOldTime= this.sourceEl.attributes['data-time'].value
            var oldDate = this.sourceEl.attributes['data-date'].value
            const date= moment(oldDate, "YYYY-MM-DD");
            const formattedDate= date.format("jYYYY/jMM/jDD");
            this.oldDate =  formattedDate
            const dayOfWeek = date.jDay();
            const daysOfWeek = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
            const dayName = daysOfWeek[dayOfWeek];
            this.oldDayName = dayName;
            if(this.destEl && this.destEl.attributes['data-timeid']){
              if(this.destEl.attributes['data-maxTurn'] && this.destEl.attributes['data-turns'].value < this.destEl.attributes['data-maxTurn'].value){
                this.newTime = this.destEl.attributes['data-time'].value;
                var newDate =  this.destEl.attributes['data-date'].value;
                const dateN = moment(newDate, "YYYY-MM-DD");
                const formattedDateN = dateN.format("jYYYY/jMM/jDD");
                this.newDate = formattedDateN;
                const dayOfWeek = dateN.jDay();
                const daysOfWeek = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
                const dayName = daysOfWeek[dayOfWeek];
                this.dayNamed = dayName;
                if(this.destEl.attributes['data-holiday'].value != 'true'){
                  if(this.newDate == this.oldDate){
                    if(this.destEl.attributes['data-time'].value != this.dateOldTime){
                      if(this.sourceEl.attributes['data-timeid'].value != this.destEl.attributes['data-timeid'].value){
                        this.showModalDrag = true  
                      }
                      else{
                        this.showModalDrag = false  
                        this.$bvToast.toast('نوبت قبلا در این ساعت و تاریخ ثبت شده است', {
                          title: this.$t("toastification.error"),
                          variant: "danger",
                          solid: true,
                        });
                        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
                      }             
                    }
                    else{
                      this.showModalDrag = false  
                      this.$bvToast.toast('نوبت قبلا در این ساعت و تاریخ ثبت شده است', {
                        title: this.$t("toastification.error"),
                        variant: "danger",
                        solid: true,
                      });
                      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
                    }
                  }
                  else{
                    if(this.sourceEl.attributes['data-timeid'].value != this.destEl.attributes['data-timeid'].value){
                      this.showModalDrag = true  
                    }
                    else{
                      this.showModalDrag = false  
                      this.$bvToast.toast('نوبت قبلا در این ساعت و تاریخ ثبت شده است', {
                        title: this.$t("toastification.error"),
                        variant: "danger",
                        solid: true,
                      });
                      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
                    }       
                  }
                }
                else{
                  this.showModalDrag = false  
                  this.$bvToast.toast('متاسفانه این تاریخ در تقویم مرکز تعطیل می باشد', {
                    title: this.$t("toastification.holiday"),
                    variant: "danger",
                    solid: true,
                  });
                  this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
                }
              }
              else{
                    // this.$bvToast.toast('در این بازه زمانی تعداد نوبت های ثبت شده حداکثر می باشد و متاسفانه امکان انتقال نوبت را ندارید' , {
                    //   title: this.$t("toastification.error"),
                    //   variant: "danger",
                    //   solid: true,
                    // });
                    this.sourceEl= null
                    this.destEl= null
                    this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
              }
            }
          }
          else{
            this.$bvToast.toast('متاسفانه انتقال نوبت امکان پذیر نمی باشد', {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
            this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
          }
        }
      }
  },
    closeModalDrag(){
      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
        this.isDragging = false
        this.showModalDrag=false
    },
    ShowQueueLists(){
      this.ShowQueueList= true
      this.showListCalendars = false
      this.$store.commit("SET_IS_LOADING", true)
      var splitDate = moment().format().split("T");
      var splitDate1 = splitDate[1].split("+");
      var spData1 = splitDate1[0].split(":");
      var spDate = `${splitDate[0]} ${spData1[0]}:${spData1[1]}`
      this.startDate = spDate
      var newToday =  moment(new Date())
        .subtract(0, "days")
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      const tt = moment(newToday).startOf("day");
      const formattedFromDate = `${tt.format("YYYY-MM-DD")}T00:00:00.000Z`;
      const payload = {
          fromDate:  formattedFromDate,
          endDate:  formattedFromDate,
          keywordForPatient: this.searchTerm,
          isDeletedForPatient:false,
          isComeForPatient:false,
          page: 1,
          limit: 100,
        };
      this.$store.dispatch("plan/searchForTurn", payload).then((res) => {
        const filterDoctor = res.data.filter(item => item.planUserId._id === this.selectDoctor);
        const filterUnit = filterDoctor.filter(item => item.unitId === this.unitSelectedId);
        this.listResult = filterUnit;
        this.$store.commit("SET_IS_LOADING", false);
      });
  },
    showListCalendar(){
      this.ShowQueueList= false
      this.showListCalendars = true
    },
    generateDate() {
      this.$store.commit("SET_IS_LOADING", true);
      
      const fromDate = moment(this.startDate).startOf('day');
      const endDate = moment(this.startDate).endOf('day');
      const formattedFromDate = `${fromDate.format("YYYY-MM-DD")}T00:00:00.000Z`;
      const formattedEndDate = `${endDate.format("YYYY-MM-DD")}T00:00:00.000Z`;
      const payload = {
        fromDate: formattedFromDate,
        endDate: formattedEndDate,
        keywordForPatient: this.searchTerm,
        isDeletedForPatient:false,
        isComeForPatient:false,
        page: 1,
        limit: 100,
      };
      this.$store.dispatch("plan/searchForTurn", payload).then((res) => {
        const filteredResults = res.data.filter(item => item.planUserId._id === this.selectDoctor);
        this.listResult = filteredResults;
        this.$store.commit("SET_IS_LOADING", false);
      });
    },
    handleKeyup(event){
      this.showList= false
      this.recently= false
      if ((event.key === "Backspace" || event.key === "Delete") && !this.selectDoctor) {
      this.showList = true;      
      this.recently= true
    }
    },
    showTooltip(index) {
      const dayElement = this.$refs.dayElement[index];  
      const tooltipContent = this.$refs.tooltipContent; 

      tooltipContent.style.display = 'block'; 
      tooltipContent.style.position = 'absolute';
      tooltipContent.style.left = (dayElement.offsetLeft - 80) + 'px'; 
      tooltipContent.style.top = (dayElement.offsetTop + dayElement.offsetHeight) + 'px';

      dayElement.appendChild(tooltipContent); 
      this.checkIndex = index
    },
    hideTooltip(index) {
      const tooltipContent = this.$refs.tooltipContent;  
      tooltipContent.style.display = 'none';  
    },
    handleDoctorSelection(row) { 
      const selectedDoctor = row._id
      var fIndex = this.users.filter(item => item._id === selectedDoctor);     
          if(fIndex.length == 1){
          this.unitSelectedId = fIndex[0].units[0]._id
          this.selectDoctor = selectedDoctor;
          this.ShowQueueList= false
          this.showListCalendars = false
          
        }
        else {
          this.unitSelectedId = null
          this.selectDoctor = selectedDoctor;
          this.showListCalendars = false
          this.ShowQueueList= false
          this.showCalendar=false
        }
        this.calculateDate(); 
        this.handleKeyup(event)
        const advanceSearchCard = document.getElementById("advanceSearchCard");
        if (advanceSearchCard.style.width === "1128px") {
          advanceSearchCard.style.transition = "width .3s ease";
          advanceSearchCard.style.width="0"
          document.querySelector(".bg-search").classList.remove('background')
          this.advancedSearch=[]
          this.searchName="",
          this.medicalSpecialtyId = "",
          this.unit=""
          this.emtResult = false;

        }
    },
    onMove(evt) {
      this.sourceEl = evt.dragged
      this.destEl = evt.related    

    },
    dragEvt() {
      setTimeout(() => { 
        if(this.destEl && this.sourceEl && this.destEl.attributes['data-turns'] && this.destEl.attributes['data-maxTurn'].value > this.destEl.attributes['data-turns'].value){
          var argPayload = {
            newPDId : this.destEl.attributes['data-planid'].value,
            newTId : this.destEl.attributes['data-timeid'].value,
            oldPDId : this.sourceEl.attributes['data-planid'].value,
            oldTId : this.sourceEl.attributes['data-timeid'].value,
            turnId : this.sourceEl.attributes['data-turnid'].value,
          }
          this.dragEvent(argPayload) 
        }
        else{
          this.$bvToast.toast('متاسفانه انتقال نوبت امکان پذیر نمی باشد', {
            title: this.$t("toastification.error"),
            variant: "danger",
            solid: true,
          });
          this.closeModalDrag()
        }         
      },500)
     
    },
    changeIsEdit(e){
      this.editable = e
    },
    filterData(item, queryText) {
      return (
          item.firstName.toLowerCase().includes(queryText.toLowerCase()) ||
          item.lastName.toLowerCase().includes(queryText.toLowerCase())
        );
    },
    newReserveData(data) {
      this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
        title: this.$t("toastification.success"),
        variant: "success",
        solid: true,
      });
      this.plans = this.plans.filter((item) => item._id !== data._id);
      this.plans.push(data);
      this.searchPlan(this.currentTime.start, this.currentTime.end);
    },
    removeReserveData() {
      const payload = {
        turnOfTimePlanDetailId: this.turnOfTimePlanDetailId,
      };
      if (!this.isComeStatus) {
        this.$store
          .dispatch("plan/deleteTurnOfPlan", {
            payload: payload,
            planDetailId: this.planId,
            timeId: this.timeId,
          })
          .then((res) => {
            this.plans = this.plans.filter((item) => item._id !== res._id);
            this.plans.push(data);
            this.searchPlan(this.currentTime.start, this.currentTime.end);
            this.$bvToast.toast(
              this.$t("toastification.deletionRequestSucceed"),
              {
                title: this.$t("toastification.success"),
                variant: "success",
                solid: true,
              }
            );
          })
          .catch((error) => {
            let msg = "";
            switch (error.response.status) {
              case 422:
                msg = this.$t("toastification.deletionFailed");
                break;

              case 404:
                msg = this.$t("toastification.deletionFailed");
                break;

              case 400:
                msg = this.$t("toastification.badRequest");
                break;
            }

            this.$bvToast.toast(msg, {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
          });
        this.searchPlan(this.currentTime.start, this.currentTime.end);
      } else {
        this.$bvToast.toast(this.$t("toastification.isComeNotDelete"), {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
      }
    },
    async IsComing(turn,planId,timeId) {
      this.reserveModal = false;
      const payload = {
        timeId: timeId,
        planDetailId: planId,
        turnOfTimePlanDetailId: turn._id,
        isCome: true,
      };
       this.reserveModal = false;
      this.$store
        .dispatch("plan/updateForCome", payload)
        .then((res) => {
          this.reserveModal = false;
          this.$bvModal.msgBoxConfirm(
            "بیمار در این نوبت ویزیت شد",
            {
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              okTitle: this.$t("general.close"),
              cancelTitle: this.$t("general.no"),
              footerClass: "p-2 max-turn-footer",
              hideHeaderClose: false,
              centered: true,
            }
          );
          this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
        })
        .catch((error) => {
          this.reserveModal = false;
          let msg = "";
          switch (error.response.status) {
            case 422:
              msg = this.$t("toastification.deletionFailed");
              break;

            case 404:
              msg = this.$t("toastification.deletionFailed");
              break;

            case 400:
              msg = this.$t("toastification.badRequest");
              break;
          }

          this.$bvToast.toast(msg, {
            title: this.$t("toastification.error"),
            variant: "danger",
            solid: true,
          });
        });
    },
    dragEvent(args) {
      this.isDragging = false
      const payload = {
        displacementPlanDetailsId: args.newPDId,
        displacementTimeId: args.newTId,
        movePlanDetailsId: args.oldPDId,
        moveTimeId: args.oldTId,
        moveTurnId: args.turnId,
      };
      this.$store.dispatch("plan/updateForMove", payload)
      .then((res) => {
        if(res[0].status != 'fail'){
          this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
            variant: "success",
            solid: true,
          });
          this.showModalDrag=false
          this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
        }
        else{
          this.$bvToast.toast(res[0].description, {
            variant: "danger",
            solid: true,
          });
          this.showModalDrag=false
          this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
        }
        
      })
      .catch((error) => {
        this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
          variant: "danger",
          solid: true,
        });
        this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      });
    },
    eventClick(selectInfo,trun,index,isPast,isHoliday,isToday) {
      if(isHoliday != true){
        this.currentTime.start = this.startDateOfWeek
        this.currentTime.end = this.endDateOfWeek
        this.reserveDate = ''
        this.reserveFromTime = ''
        this.reserveEndTime = ''
        this.planId = ''
        this.timeId =  ''
        this.turnOfTimePlanDetailId = ''
        this.turnUserId = ''
        this.isComeStatus = false;
        this.doctorInfo = {}
        this.keyDay = null
        if(isToday == null || isToday == undefined){
          this.isToday = false
        }
        else{
          this.isToday = isToday
        }
        var formatDay = new Date(selectInfo.date)
        var date = new Intl.DateTimeFormat('fa-IR').format(formatDay);
        if(trun){
          this.currentPast = isPast
          this.reserveDate = date
          this.reserveFromTime = selectInfo.items.time.fromTime
          this.reserveEndTime = selectInfo.items.time.endTime
          this.planId = selectInfo.items.planDetail._id
          this.timeId =  selectInfo.items.time._id
          this.keyDay = index
          this.turnOfTimePlanDetailId = trun._id;
          this.turnUserId = trun.turnUserId._id;
          this.isComeStatus = trun.isCome;
          this.doctorInfo = selectInfo.items.planDetail
          this.reserveModal = true;
        }
        else {
          if(isPast == false){
            this.reserveDate = date
            this.reserveFromTime = selectInfo.items.time.fromTime
            this.reserveEndTime = selectInfo.items.time.endTime
            this.planId = selectInfo.items.planDetail._id
            this.timeId =  selectInfo.items.time._id
            this.keyDay = index
            this.doctorInfo = selectInfo.items.planDetail
            var hasTrun = 0
            hasTrun = selectInfo.items.time.turns.filter(n => n.isDeleted == false).length
            if(selectInfo.items.time.maxTurn == hasTrun){
              this.reserveModal = false;
              this.$bvModal.msgBoxConfirm(
                "بیش از حد مجاز - امکان رزرو در این بازه زمانی وجود ندارد",
                {
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "danger",
                  okTitle: this.$t("general.close"),
                  cancelTitle: this.$t("general.no"),
                  footerClass: "p-2 max-turn-footer",
                  hideHeaderClose: false,
                  centered: true,
                }
              );
            }
            else{
              this.reserveModal = true;
            }
          }
          else{
            this.$bvToast.toast('امکان ثبت نوبت به دلیل اینکه زمان این نوبت در تقویم گذشته شده وجود ندارد', {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
          }
        }
      }
      else{
        if(isToday != true){
          this.$bvToast.toast('متاسفانه این تاریخ در تقویم مرکز تعطیل می باشد', {
            title: this.$t("toastification.holiday"),
            variant: "danger",
            solid: true,
          });
        }
        else{
          this.currentTime.start = this.startDateOfWeek
          this.currentTime.end = this.endDateOfWeek
          this.reserveDate = ''
          this.reserveFromTime = ''
          this.reserveEndTime = ''
          this.planId = ''
          this.timeId =  ''
          this.turnOfTimePlanDetailId = ''
          this.turnUserId = ''
          this.isComeStatus = false;
          this.doctorInfo = {}
          this.keyDay = null
          if(isToday == null || isToday == undefined){
            this.isToday = false
          }
          else{
            this.isToday = isToday
          }
          var formatDay = new Date(selectInfo.date)
          var date = new Intl.DateTimeFormat('fa-IR').format(formatDay);
          if(trun){
            this.currentPast = isPast
            this.reserveDate = date
            this.reserveFromTime = selectInfo.items.time.fromTime
            this.reserveEndTime = selectInfo.items.time.endTime
            this.planId = selectInfo.items.planDetail._id
            this.timeId =  selectInfo.items.time._id
            this.keyDay = index
            this.turnOfTimePlanDetailId = trun._id;
            this.turnUserId = trun.turnUserId._id;
            this.isComeStatus = trun.isCome;
            this.doctorInfo = selectInfo.items.planDetail
            this.reserveModal = true;
          }
          else {
            if(isPast == false){
              this.reserveDate = date
              this.reserveFromTime = selectInfo.items.time.fromTime
              this.reserveEndTime = selectInfo.items.time.endTime
              this.planId = selectInfo.items.planDetail._id
              this.timeId =  selectInfo.items.time._id
              this.keyDay = index
              this.doctorInfo = selectInfo.items.planDetail
              var hasTrun = 0
              hasTrun = selectInfo.items.time.turns.filter(n => n.isDeleted == false).length
              if(selectInfo.items.time.maxTurn == hasTrun){
                this.reserveModal = false;
                this.$bvModal.msgBoxConfirm(
                  "بیش از حد مجاز - امکان رزرو در این بازه زمانی وجود ندارد",
                  {
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.$t("general.close"),
                    cancelTitle: this.$t("general.no"),
                    footerClass: "p-2 max-turn-footer",
                    hideHeaderClose: false,
                    centered: true,
                  }
                );
              }
              else{
                this.reserveModal = true;
              }
            }
            else{
              this.$bvToast.toast('امکان ثبت نوبت به دلیل اینکه زمان این نوبت در تقویم گذشته شده وجود ندارد', {
                title: this.$t("toastification.error"),
                variant: "danger",
                solid: true,
              });
            }
          }
        }
      }
    },
    updateCal (){
      this.searchPlan(this.currentTime.start, this.currentTime.end);
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    searchUser() {
      // let payload = {};
      // if (this.roleFilter && this.roleFilter.length) {
      //   payload.roles = this.roleFilter;
      // }
      // payload.page = 1;
      // // payload.limit = 20;
      const payload={
        page:1,
        roleTitle:"doctor"
      }
      this.$store.dispatch("user/searchUsers", payload).then((res) => {
        if(res && res != undefined ){
          this.users = [...res];
        }
      });
    },
    addUserToFront(userId, usersList) {
      const isUserInRecentSearches = usersList.some((user) => user._id === userId);
      if (!isUserInRecentSearches) {
        return [{ ...usersList.find((user) => user._id === userId) }, ...usersList];
      }
      return usersList;
    },

    addToRecentSearches(recentSearchItem) {
    const existingIndex = this.recentSearches.findIndex((item) => item._id === recentSearchItem._id);
      if (existingIndex !== -1) {
        this.recentSearches.splice(existingIndex, 1);
      }
      this.recentSearches.unshift(recentSearchItem);
      this.recentSearches = this.recentSearches.slice(0, 4);
      localStorage.setItem("selectedDoctors", JSON.stringify(this.recentSearches));
    },
    searchPlan(start, end) {
      // this.showCalendar = false
      // this.isLoading = true
      this.findUser();
      this.initial_events = [];
      this.rangeDates = [];
      this.allowDates = [];
      this.ShowQueueList= false
     this.showListCalendars = true
      const payload = {
        dayDate: start,
        //endDate: end,
        planUserId: this.selectDoctor,
        status: "in_use",
        unitId : this.unitSelectedId
      };
      for (let i = 0; i < 7; i++) {
        this.rangeDates.push(
          moment(start)
            .add(i, "day")
            .format("YYYY-MM-DD")
            .toLocaleString("en-GB", { timeZone: "UTC" })
        );
      }
      this.$store.dispatch("plan/searchPlanWeek", payload).then((res) => {
        this.showActionBtn = true
        this.weekDayArray = []
        this.timeArray = []
        var splitted1 = res.fromTime.split(":");
        var splitted2 = res.endTime.split(":");
        if(splitted1[0] == '00'){
          splitted1[0] = '24'
        }
        if(splitted2[0] == '00'){
          splitted2[0] = '24'
        }
        var hour1 = parseInt(splitted1[0]);
        var min1 = parseInt(splitted1[1]);
        var hour2 = parseInt(splitted2[0]);
        var min2 = parseInt(splitted2[1]);
        var diffHour = null
        var diffMin = null
        if(hour2 > hour1){
          if(min1>min2){
            hour2 = hour2 - 1
            min2 = min2 + 60
            diffHour = hour2 - hour1
            diffMin = min2 - min1
          }
          else{
            diffHour = hour2 - hour1
            diffMin = min2 - min1
          }
        }
        else if(hour2 == hour1){
          diffHour = hour2 - hour1
          diffMin = min2 - min1
        }
        var allMin = ( diffHour * 60 ) + diffMin + 1
        var rem = allMin % 12
        if(rem > 0){
          this.hoursShift = (allMin / 12) + 1
        }
        else{
          this.hoursShift = allMin / 12
        }
        var rem1 = allMin % diffHour
        var isRem = false
        var oldMins = allMin
        if(rem1>0){
          diffHour = diffHour + 1
          allMin = diffHour * 60
          this.allHours = diffHour
          isRem = true
        }
        else{
          this.allHours = diffHour
        }
        
        if(min2 > 0 && isRem != true){
          this.allHours =this.allHours +1
          this.dayParts = 12 * (diffHour + 1)
        }
        else{
          this.allHours =this.allHours 
          this.dayParts = 12 * diffHour
        }
        this.startHour = hour1
        if (res.data) {
          this.noPlan = false
          var keys = Object.keys(res.data)
          this.isHolidays = null
          var oldTime = null
          var oldStartTime = null
          var turnCount = 0
          var checkHoliday = []
          var calHolidays = []
          calHolidays = res.holidays
          this.holidaysList = res.holidays
          for(let z = 0;z<calHolidays.length;z++){
            if(calHolidays[z] != ''){
               checkHoliday.push(true)
            }
            else{
              checkHoliday.push(false)
            }
          }
          this.isHolidays = checkHoliday
          for(let q =0 ;q<keys.length;q++){
            var formatDay = new Date(keys[q])
            var date = new Intl.DateTimeFormat('fa-IR').format(formatDay);
            this.weekDayArray.push({
                dayTime: date,
                geoDate : keys[q],
                times:[],
                isHoliday: checkHoliday[q]
            })    
            var timekeys = Object.keys(res.data[keys[q]])
            if(res.data[keys[q]][timekeys[0]].length == 0 ){
              this.isNotToShow = true
              
            }
            else{
              this.isNotToShow = false
            }
            for(let i= 0;i<timekeys.length;i++){
              if(res.data[keys[q]] && res.data[keys[q]][timekeys[i]] && res.data[keys[q]][timekeys[i]].data && res.data[keys[q]][timekeys[i]].data.time && res.data[keys[q]][timekeys[i]].data.time.maxTurn && res.data[keys[q]][timekeys[i]].data.time.turns){
                oldTime = null
                oldStartTime = null
                turnCount = 0
                if(res.data[keys[q]][timekeys[i]].isHoliday){
                  this.weekDayArray[q].isHoliday = `${res.data[keys[q]][timekeys[i]].isHoliday}`
                }
                if(res.data[keys[q]][timekeys[i]].oldTimeId == null){
                  this.weekDayArray[q].times.push({
                    time: timekeys[i],
                    date: keys[q],
                    items: res.data[keys[q]][timekeys[i]].data,
                    maxTurn: res.data[keys[q]][timekeys[i]].data.time.maxTurn,
                    hasTurn: res.data[keys[q]][timekeys[i]].data.time.turns,
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount : res.data[keys[q]][timekeys[i]].data.time.turns.filter(n => n.isDeleted == false).length,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  this.timeArray.push({
                    time: timekeys[i],
                    date: keys[q],
                    items: res.data[keys[q]][timekeys[i]].data,
                    maxTurn: res.data[keys[q]][timekeys[i]].data.time.maxTurn,
                    hasTurn: res.data[keys[q]][timekeys[i]].data.time.turns,
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount : res.data[keys[q]][timekeys[i]].data.time.turns.filter(n => n.isDeleted == false).length,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  oldStartTime = timekeys[i]
                  turnCount = res.data[keys[q]][timekeys[i]].data.time.turns.filter(n => n.isDeleted == false).length
                }
                else if(res.data[keys[q]][timekeys[i]].oldTimeId && res.data[keys[q]][timekeys[i]].oldTimeId == res.data[keys[q]][timekeys[i]].timeId){
                  this.weekDayArray[q].times.push({
                    time: oldStartTime,
                    date: keys[q],
                    items: res.data[keys[q]][timekeys[i]].data,
                    maxTurn: res.data[keys[q]][timekeys[i]].data.time.maxTurn,
                    hasTurn: res.data[keys[q]][timekeys[i]].data.time.turns,
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount : turnCount,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  this.timeArray.push({
                    time: oldStartTime,
                    date: keys[q],
                    items: res.data[keys[q]][timekeys[i]].data,
                    maxTurn: res.data[keys[q]][timekeys[i]].data.time.maxTurn,
                    hasTurn: res.data[keys[q]][timekeys[i]].data.time.turns,
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount : turnCount,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                }
                else{
                  this.weekDayArray[q].times.push({
                    time: timekeys[i],
                    date: keys[q],
                    items: res.data[keys[q]][timekeys[i]].data,
                    maxTurn: res.data[keys[q]][timekeys[i]].data.time.maxTurn,
                    hasTurn: res.data[keys[q]][timekeys[i]].data.time.turns,
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount: res.data[keys[q]][timekeys[i]].data.time.turns.filter(n => n.isDeleted == false).length,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  this.timeArray.push({
                    time: timekeys[i],
                    date: keys[q],
                    items: res.data[keys[q]][timekeys[i]].data,
                    maxTurn: res.data[keys[q]][timekeys[i]].data.time.maxTurn,
                    hasTurn: res.data[keys[q]][timekeys[i]].data.time.turns,
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount: res.data[keys[q]][timekeys[i]].data.time.turns.filter(n => n.isDeleted == false).length,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  oldStartTime = timekeys[i]
                  turnCount = res.data[keys[q]][timekeys[i]].data.time.turns.filter(n => n.isDeleted == false).length
                }
                oldTime = res.data[keys[q]][timekeys[i]].data
              }
              else if(res.data[keys[q]] && res.data[keys[q]][timekeys[i]] && res.data[keys[q]][timekeys[i]].oldTimeId){
                if(res.data[keys[q]][timekeys[i]].isHoliday){
                  this.weekDayArray[q].isHoliday = `${res.data[keys[q]][timekeys[i]].isHoliday}`
                }
                if(res.data[keys[q]][timekeys[i]].oldTimeId == res.data[keys[q]][timekeys[i]].timeId){
                  this.weekDayArray[q].times.push({
                    time: oldStartTime,
                    date: keys[q],
                    items: oldTime,
                    maxTurn: oldTime.time.maxTurn,
                    hasTurn: [],
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount: turnCount,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  this.timeArray.push({
                    time: oldStartTime,
                    date: keys[q],
                    items: oldTime,
                    maxTurn: oldTime.time.maxTurn,
                    hasTurn: [],
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount: turnCount,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                }
                else{
                  this.weekDayArray[q].times.push({
                    time: timekeys[i],
                    date: keys[q],
                    items: oldTime,
                    maxTurn: oldTime.time.maxTurn,
                    hasTurn: [],
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount: 0 ,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  this.timeArray.push({
                    time: timekeys[i],
                    date: keys[q],
                    items: oldTime,
                    maxTurn: oldTime.time.maxTurn,
                    hasTurn: [],
                    timeId: res.data[keys[q]][timekeys[i]].timeId,
                    oldTimeId: res.data[keys[q]][timekeys[i]].oldTimeId,
                    turnCount: 0,
                    isPast : res.data[keys[q]][timekeys[i]].isPastTime,
                    isToday : res.data[keys[q]][timekeys[i]].isToday,
                    isHoliday : res.data[keys[q]][timekeys[i]].isHoliday
                  })
                  oldStartTime = timekeys[i]
                  turnCount = 0
                }
              }
              else{
                this.weekDayArray[q].isHoliday = 'false'
                this.weekDayArray[q].times.push({
                  time: timekeys[i],
                  date: keys[q],
                  items: [],
                  maxTurn: 0,
                  hasTurn: [],
                  timeId: q,
                  oldTimeId: q+100,
                  turnCount : 0,
                  isPast : 'false',
                  isToday : 'false',
                  isHoliday : 'false',
                })
                this.timeArray.push({
                  time: timekeys[i],
                  date: keys[q],
                  items: [],
                  maxTurn: 0,
                  hasTurn: [],
                  timeId: q,
                  oldTimeId: q+100,
                  turnCount: 0,
                  isPast : 'false',
                  isToday : 'false',
                  isHoliday : 'false',
                })
              }
            }
          }
          this.isLoading = false
          this.showCalendar = true
        }
      })
      .catch((error) =>{
        this.showCalendar = false
        this.isLoading = false
        this.noPlan = true
        this.showActionBtn = false
        if( error && this.unitSelectedId !== null && this.noPlan === true &&  this.showListCalendars === true){
              this.$bvToast.toast('متاسفانه برنامه ای برای پزشک در این هفته تعریف نشده است', {
                title: this.$t("toastification.error"),
                variant: "danger",
                solid: true,
              });     
      }
      })
    },
    
    next() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.next();
      this.calculateDate();
    },
    prev() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.prev();
      this.calculateDate();
    },
    today() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.today();
      this.calculateDate();
    },
    removeTrun() {
      if (this.isComeStatus == false) {
        const payload = {
          timeId: this.timeId,
          planDetailId: this.planId,
          turnId:  this.turnOfTimePlanDetailId
        }
        this.$store
          .dispatch("plan/deleteTurnOfPlan", payload)
          .then((res) => {
            this.$bvToast.toast(
              this.$t("toastification.deletionRequestSucceed"),
              {
                title: this.$t("toastification.success"),
                variant: "success",
                solid: true,
              }
            );
            this.searchPlan(this.currentTime.start, this.currentTime.end);
          })
          .catch((error) => {
            let msg = "";
            switch (error.response.status) {
              case 422:
                msg = this.$t("toastification.deletionFailed");
                break;

              case 404:
                msg = this.$t("toastification.deletionFailed");
                break;

              case 400:
                msg = this.$t("toastification.badRequest");
                break;
            }

            this.$bvToast.toast(msg, {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
          });
      } else {
        this.$bvToast.toast(this.$t("toastification.isComeNotDelete"), {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
      }
    },
    calculateDate() {
      const today = new Date();
      if (moment(today).format("ddd") === "Fri") {
        this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - today.getDay() - 1
        );
        this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (6 - today.getDay())
        );
      } else if (moment(today).format("ddd") === "Sat") {
        this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - today.getDay() + 6
        );
        this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (12 - today.getDay())
        );
      } else {
        this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );
        this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (11 - today.getDay())
        );
      }
      this.startDateOfWeek = moment(this.firstDayOfWeek)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      this.endDateOfWeek = moment(this.lastDayOfWeek)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
    },
    calculateDate1(date) {
      var splitDate = date.split("T")
      const currentDate = splitDate[0]
      var newCurrent = new Date(currentDate)
      this.currentCal = new Intl.DateTimeFormat('fa-IR').format(newCurrent);
      this.isChangeDate = true
      const today = new Date(currentDate)
      if (moment(today).format("ddd") === "Fri") {
        this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - today.getDay() - 1
        );
        this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (6 - today.getDay())
        );
      } else if (moment(today).format("ddd") === "Sat") {
        this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - today.getDay() + 6
        );
        this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (12 - today.getDay())
        );
      } else {
        this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );
        this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (11 - today.getDay())
        );
      }
      this.startDateOfWeek = moment(this.firstDayOfWeek)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      this.endDateOfWeek = moment(this.lastDayOfWeek)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
      this.isDragging = false
    },
    closeM() {
      this.reserveModal = false;
      this.reserveDate = ''
      this.reserveFromTime = ''
      this.reserveEndTime = ''
      this.planId = ''
      this.timeId =  ''
      this.turnOfTimePlanDetailId = ''
      this.turnUserId = ''
      this.isComeStatus = false;
      this.doctorInfo = {}
      this.keyDay = null
    },
    prevWeek (){
      this.isLoading=true
      this.showCalendar=false
      this.selectedDate = null
      this.isChangeDate = false
      var start_date = moment(this.startDateOfWeek).subtract(7, 'days').format("YYYY-MM-DD")
      this.startDateOfWeek = start_date
      var end_date =moment(this.startDateOfWeek).subtract(7, 'days').format("YYYY-MM-DD")
      this.endDateOfWeek = end_date
      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
    },
    goToToday () {
      this.isLoading=true
      this.showCalendar=false
      this.selectedDate = null
      this.isChangeDate = false
      const today = new Date();
      this.firstDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
      );
      this.lastDayOfWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + (11 - today.getDay())
        );
     this.startDateOfWeek = moment(this.firstDayOfWeek)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      this.endDateOfWeek = moment(this.lastDayOfWeek)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
    },
    nextWeek (){
      this.isLoading=true
      this.showCalendar=false
      this.selectedDate = null
      this.isChangeDate = false
      var start_date = moment(this.startDateOfWeek).add(7, 'days').format("YYYY-MM-DD")
      this.startDateOfWeek = start_date
      var end_date = moment(this.startDateOfWeek).add(7, 'days').format("YYYY-MM-DD")
      this.endDateOfWeek = end_date
      this.searchPlan(this.startDateOfWeek, this.endDateOfWeek);
    },
    DateSelectDate(){
      this.isLoading=true
      this.showCalendar=false
    },
    checkAllowedDays(startInfo) {
      const startDate = startInfo.start;
      const endDate = startInfo.end;
      const date = moment(startDate).format("YYYY-MM-DD");
      this.reserveFromTime = moment(startDate).format("HH:mm");
      this.reserveEndTime = moment(endDate).format("HH:mm");
      const datesToDeleteSet = new Set(this.allowDates);
      this.notAllowDates = this.rangeDates.filter((date) => {
        return !datesToDeleteSet.has(date);
      });
      if (this.notAllowDates.includes(date)) {
        return false;
      } else {
        return true;
      }
    },
    selectRecentSearch(recentSearchItem) {
      this.selectDoctor = recentSearchItem._id;
    },
    findUser() {
      if (this.selectDoctor) {
        this.$store.dispatch("user/findUser", this.selectDoctor).then((res) => {
        this.doctorInfo = {
          doctorName: res.firstName + " " + res.lastName,
          medicalSpecialtyId: res.medicalSpecialtyId,
        };
        this.users = this.addUserToFront(res._id, this.users); 
        localStorage.setItem("selectedDoctors", JSON.stringify(this.users));
        this.recentSearchItem = {
          _id: res._id,
          firstName: res.firstName,
          lastName: res.lastName,
          avatar: res.avatar
        };
        this.addToRecentSearches(this.recentSearchItem);
      });
    }
  },

  async searchAdvance() {
    if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(async () => {
        let payload = {}
        payload.roleTitle = "doctor";

        if (this.searchName) {
            payload.keyword = this.searchName;
        }
        if (this.unit.length > 0) {
            payload.units = [this.unit];
        }
        if (this.medicalSpecialtyId) {
            payload.medicalSpecialtyId = this.medicalSpecialtyId;
        }

        if (this.searchName || this.unit.length > 0 || this.medicalSpecialtyId) {
            this.$store.commit("SET_IS_LOADING", true);
            if (!this.isMedicalSpecialtiesLoaded) {
                await new Promise((resolve) => setTimeout(resolve, 500));
                this.$store.commit("SET_IS_LOADING", false);
            }
            this.$store.dispatch("user/searchUsers", payload).then((res) => {
                this.$store.commit("SET_IS_LOADING", false);
                if (res) {
                    this.advancedSearch = res;
                    this.emtResult = false;
                    this.emtResult = this.advancedSearch.length === 0;
                } else {
                    this.emtResult = true;
                    this.advancedSearch = [];
                }
            }).catch((err) => {
                this.$store.commit("SET_IS_LOADING", false);
            });
        } else {
            this.$store.commit("SET_IS_LOADING", false);
            this.$bvToast.toast(this.$t("toastification.SearchError"), {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
        }
    }, 500);
},

    getDoctorIdselected(item) {
      this.doctorIdSelected = item._id;
      this.doctorName = item.firstName + " " + item.lastName;
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    showadvanceSearch(){
      const advanceSearchCard = document.getElementById("advanceSearchCard");
      const background = document.querySelector(".bg-search");
      if (advanceSearchCard.style.width === "1128px") {
          advanceSearchCard.style.transition = "width .6s ease";
          background.classList.remove('background')
          advanceSearchCard.style.width="0"
          this.advancedSearch=[]
          this.searchName="",
          this.medicalSpecialtyId = "",
          this.unit=""
          this.emtResult = false;
          

        } else {
          advanceSearchCard.style.transition = "width .3s ease";
          advanceSearchCard.style.width="1128px"
          background.classList.add('background')
        }
    },
    closeAdvanceSearch(){
      if (advanceSearchCard.style.width === "1128px") {
          advanceSearchCard.style.transition = "width .3s ease";
          advanceSearchCard.style.width="0"
          document.querySelector(".bg-search").classList.remove('background')
          this.advancedSearch=[]
          this.searchName="",
          this.medicalSpecialtyId = "",
          this.unit=""
          this.emtResult = false;
        }
    },
    closeShowMsg(){
      this.showMessage = false
    },
    closeShowMove(){
      this.showMove = false
    },
    isSelected(row) {
            return this.listSelect.includes(row);
    },
    toggleCheckbox(row) {
      if (this.isSelected(row)) {
          const index = this.listSelect.findIndex(item => item === row);
          if (index !== -1) {
              this.listSelect.splice(index, 1);
          }
      } else {
          this.listSelect.push(row);
      }
    }
  },
  watch: {
    selectDoctor() {
      if(this.selectDoctor != null){
        this.unitOption = []
        this.unitSelectedId = null
        this.showCalendar=false
        var fIndex = this.users.findIndex(item => item._id === this.selectDoctor);
        this.unitOption = this.users[fIndex].units 
        if(this.unitOption.length == 1){
          this.unitSelectedId = this.unitOption[0]._id
        }
      }
    },
    unitSelectedId(newValue,oldValue){
      if(newValue != null && oldValue != newValue){
        this.isLoading=true
        this.isChangeDate = false
         this.showCalendar=false
      }
      this.selectedDate = null
      if(this.unitSelectedId != null){
        this.calculateDate();
        this.$store.dispatch("plan/searchLastInUsePlan", this.selectDoctor)
        .then((res)=>{
          if(res){
            this.detailPlans= res
            this.isNotToShow = false
          }else{
              this.isNotToShow = true
            }
        })
      }
    },
    selectedDate(newValue,oldValue) {
      if(oldValue != newValue){
        this.calculateDate1(newValue);
      }
      else if (newValue == '' || newValue == null || newValue == undefined){
        this.calculateDate();
      }
    },
    isDragging(newValue,oldValue) {
      // if(newValue == true && oldValue == false){
      //   setTimeout(() => {
      //     this.dragEvt()       
      //   },1200)
      // }
      
      // if(newValue == false && oldValue == true){
      //   this.dragEvt()
      //   this.delayedDragging = false;
      // }

    }
  },
};
</script>
<style>
.c-pointer{
  cursor: pointer;
}
.c-error{
  cursor : not-allowed;
}
.vertical-layout .navbar.header-navbar.floating-nav{
  position: absolute !important;
}
.navbar-floating .header-navbar-shadow {
  position: absolute !important;
}
.topMenuCal{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position:relative;
}
ul.trun-box, .ulClass{
  margin: 0 !important
}
.trun-box li {
  list-style: none;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}
.calendar-box { 
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.headerCal {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 1;
}
.headerTitle{
  width: 10%;
  display: flex;
  flex-direction: column;
}
.dayTitle{
  width: 90%;
  display: flex;
  flex-direction: row;
}
.titleCal{
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e3e3e3;
  align-items: center;
  height: 100%;
  justify-content: center
}
.headerCal .daysBox {
  align-items: center;
  justify-content: center
}
.headerCal .daysBox.today {
  background: #ffddbdcb
}
.headerCal .daysBox.currentDay{
  background: #e1f7f6
}
.bodyCal {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}
.timeSheet{
  display: flex;
  flex-direction: column;
  width: 10%;
  border: 1px solid #e3e3e3;
  align-items: center;
  justify-content: space-between
}
.weekDayTime{
  display: flex;
  flex-direction: row;
  width: 90%;
  align-items: center;
  justify-content: center
}
.timeSheet .timeBox{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  height: calc(100% / 9);
}
.timeBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  text-align: center
}
.mainCal{
  display: flex;
  flex-direction: column;
  width: 90%
}
.weekDayTime .daysBox{
  display: flex;
  flex-direction: column !important;
}
.timeBoxOnDay{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% / 9);
}
.daysBox {
  display: flex;
  flex-direction: column;
  width: calc(100% / 6);
  border: 1px solid #e3e3e3;
  height: 100%;
}
.hourPart { 
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-bottom: 2px solid #e3e3e3;
  /* height: calc(100% / 11); */
}
.plan{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-top: 1px solid #e3e3e3;
  /* height: calc(100% / 11); */
}
.plan.isBorderT{
  border-top: 1px solid transparent !important;
}
.plan.isBorderT .noTime {
  background-color: #ffffff ;
}
/* .plan:nth-child(3n){
  border-bottom: 2px solid #e3e3e3;
}
.plan:nth-child(6n){
  border-bottom: 3px solid #e3e3e3 !important;
}
.plan:nth-child(9n){
  border-bottom: 4px solid #e3e3e3 !important;
}*/
.plan:nth-child(12n){
  border-bottom: 2px solid #dad9d9 !important
} 
.h12{
  height: calc(100% / 12);
}
.h6{
  height: calc(100% / 6);
}
.h4{
  height: calc(100% / 4);
}
.h3{
  height: calc(100% / 3);
}
.h2{
  height: calc(100% / 2);
}
.h1{
  height: calc(100% / 1);
}
.plan .v-btn:not(.v-btn--round).v-size--default {
    padding: 0 0 !important;
    border: none;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    
}
.plan .hasTime{
  background: #ffffff;
  text-align: center;
  width: 100%;
  height: 100%;
  color: #757575;
  font-weight: 500;
      display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 3px;
}
.plan .hasTime .nobat {
  width: 100%;
  height: 100%;
  cursor:pointer
}
.plan .isTime {
  background: #ffffff;
  text-align: center;
  width: 100%;
  height: 100%;
  color: #757575;
  font-weight: 500;
}
.plan .noTime{
  background: #f1f1f1;
  text-align: center;
  width: 100%;
  height: 100%;
  color: #757575;
  font-weight: 500;
}
.sheet{
  width: 100%;
    display: flex;
    flex-direction: row;
    height: 100%;
    border-top: 1px solid #e3e3e3;
    border-bottom: 2px solid #dad9d9 !important;
    align-items: center;
    justify-content: center;
}
.daysBox span {
  font-weight: bold;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.daysBox span p{
  font-weight: light !important;
  font-size: 9px;
  display: inline-flex;
  margin: 0;
}
.plan .hasTurn{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
}
.hasTurn .isTime {
  font-weight: 200;
  padding: 0 1px;
}
.hasTurn .isTime .trun-box-el{
  font-weight: 400;
  background: linear-gradient( -118deg, #02b3aa, #00a09873);
  border-radius: 2px;
  color: #ffffff;
  box-shadow: 0 0 1px 0px #000000;
  padding: 0 2px;
  z-index: 500;
}
.btn-week{
   margin: 6px 0;
   display:flex;
   flex-direction: row;
   justify-content: flex-end;
}
.nextWeekBtn{
  padding: 5px 10px;
  color: white;
  background: linear-gradient( 118deg, #02b3aa, #00a09873);
  margin: 0 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0px #00a0987d;
}
.prevWeekBtn{
  padding: 5px 10px;
  color: white;
  background: linear-gradient( -118deg, #02b3aa, #00a09873);
  margin: 0 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0px #00a0987d;
}
.todayBtn{
  padding: 5px 10px;
  color: white;
  background: #15b7ae;
  margin: 0 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0px #00a0987d;
}
.trun-box{
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 20.3px;
}
.trun-box-el{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 20.3px;
  width: 30px;
  padding: 0 !important;
}
.trun-box-el span{
  font-size: 10px;
  min-width: 21px;
  cursor: zoom-in;
}
.removeTurnClass {
  color: rgb(215, 84, 84);
  padding: 0 2px 0 0;
}
.dropDownTurn {
  background: transparent !important;
  padding: 0 !important;
  border: none !important
}
.dropDownTurn button{
  background: transparent !important;
  padding: 0 !important;
  border: none !important
}
.dropDownTurn .btn::before{
  display: none
}
.dropDownTurn .dropdown-menu{
  transform: translate3d(-25px, 0px, 0px) !important;
  width: auto;
}
.v-application .primary--text{
  color: #02b3aa !important;
}

.theme--light.v-label{
 color: #05b4ab !important}

 .v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__selections{
  padding-top: 21px;
 }
 .theme--light.v-text-field--filled > .v-input__control > .v-input__slot{
  box-shadow: 5px 4px 6px -3px #00a0987d;
  background-color: white !important;
 }
.v-autocomplete__content.v-menu__content{
  top: 57px !important;
  z-index: 8 !important;
  left: 4px;
}
.v-application--wrap{
  z-index: 10 !important;
  position: relative;
  height: 38px;
  overflow: hidden;
  padding: 0px 5px;
  border-radius: 6px !important;
  border: 1px solid #d8d6de;
}
.v-text-field--rounded{
  border-radius: 10px;
  height: 38px !important;

}
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot{
  box-shadow: none !important;
}
.avatar-user{
  width: 20px;
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  border-radius: 5px;
  margin-right: 5px;
  border:1px solid  #e2e2e2;
}
.v-application--is-ltr .v-list-item__avatar:first-child{
  margin-right: 0 !important;
}
.v-list .firstSecTitle span{
  background: #fff;
  padding: 10px 15px 10px 0;
  position: relative;
  z-index: 1111;
}
.v-list .firstSecTitle::before{
  border-bottom: 1px solid #e3e3e3;
  content: '';
      position: absolute;
    top: 25px;
    width: 100%;
    z-index: 1;
}
.v-text-field--filled .v-label{
  top: 20px;
}
.theme--light.v-application{
  width: 355px !important;
}
.v-text-field--rounded > .v-input__control > .v-input__slot{
  padding: 0 8px !important;
}
.v-label--active{
  top: 10px !important;
}
.labe-search{
  font-weight: 500;
  font-size: 16px;
  color: #13b7af;
}
#modal-scoped .modal-footer{ display: none;}
.advanceSearch .vs__dropdown-toggle{
  white-space: nowrap;
  overflow: hidden;
  height: 38px;
  text-overflow: ellipsis;
}
.advanceSearch .vs__dropdown-toggle .vs__selected-options{
  white-space: nowrap;
  overflow: hidden;
  height: 38px;
  text-overflow: ellipsis;
}
.cal-page .v-text-field--filled>.v-input__control>.v-input__slot, .v-text-field--full-width>.v-input__control>.v-input__slot, .v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 38px;
}
.cal-page .v-autocomplete__content.v-menu__content {
    top: 39px !important;
}
.cal-page .v-select[dir=rtl] .vs__dropdown-menu {
    text-align: right;
    top: 39px;
}
.cal-page label {
    margin-bottom: 0px;
}
.cal-page .form-control.pdp{
  height: 28px !important;
}
.searchBtn{
  position: absolute;
  top: 14%;
  transform: rotate(90deg);
  left: -91px;
  border-radius: 0;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 32px;
  padding: 0;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;

}
.advanceSearch-card{
position: fixed;
width: 0;
right: 0%;
z-index: 300;
background: white;
border: 1px solid #11b7ae;
height: 420px;
top:33% !important
}
.user-result{
  overflow: scroll;
  height: 295px;
  padding: 1px 0 0 0!important;
}
.user-result .vgt-responsive{
  height: 300px;
  overflow: scroll;
}
.zoom-fade-enter {
  transform:none;
  opacity: 0;
}

.zoom-fade-leave-to {
  transform:none;
  opacity: 0;
}
.btn-group.group button{
  background-color: #15B7AE !important;
  color: white !important;
  border: 1px solid #7ed0cc;
  height: 36px !important;
}
.btn-group.option button{
  margin-left: 5px;
  border-radius: 4px !important;
}
.modalsendMessage .form-group textarea.form-control{
  height: 50px;
}
.modalsendMessage .modal-footer{
  padding:10px 20px
}
.modalsendMessage , .modalShowMove{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1050;
  right: 0;
  background-color: #0f0f0fb0 !important;
  padding-top: 50px;
  height: 100%;

}
.modalsendMessage , .modalShowMove .form-group small{
  color: #938b8b;
  margin-top: 4px;
}
.notices{
  font-size: 14px;
  margin: 0;
}
.modalShowMove .form-group textarea.form-control{
  height: 50px;
}
.modalShowMove .modal-dialog{
  width:600px;
  max-width: 600px;
}
.modalShowMove .modal-footer{
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;

}
.modalShowMove .modal-header ,.modal-footer {
  background: #ebe9f126;
}

.modalsendMessage .modal-header , .modal-footer{
  background: #ebe9f126;
}

.notices .form-check{
  margin-left:4px;
}
.transfer-list{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom:15px
}
#tooltip-content thead{
  border: 1px solid  #cccccc8f;
  background: white;
}
#tooltip-content table{
  background: white;

}
#tooltip-content thead tr th{
  padding: 8px 15px;
  border: 1px solid  #cccccc8f;

}
#tooltip-content tbody tr td{
  padding: 8px 20px;
  border: 1px solid  #cccccc8f;
  text-align: center;

}
#tooltip-content::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent  #cccccc8f transparent;
}
.emtResult{
  text-align: center;
  font-size: 20px;
}
.bgChangeActive{
  background-color: #02b3aa  !important;

}
.bgButton{
  background:  #4fc5c0;
  color: white !important;
}
.background{
background: #403c3c94;
width: 100%;
height: 100vh;
position: fixed;
top: 0;
z-index: 1100;
left: 0;
}
.cal-page .bgButton1{
  border-radius: 0 5px 5px 0 !important;
  border: 1px solid #4fc5c0;
  background: #ffffff !important;
  color: #15b7ae !important;
}
.cal-page .bgButton2{
  border-radius: 5px 0 0 5px !important;
  border: 1px solid #4fc5c0;
  background: #ffffff !important;
  color: #15b7ae !important;
}
.cal-page .bgButton1.bgChangeActive,.cal-page .bgButton2.bgChangeActive{
  background: #15b7ae !important;
  color: #ffffff !important;
}
#start-time2 .form-control.pdp{
  height: 38px !important;
}
.daysBox.holiday{
  background: #facece;
}
.daysBox.holiday .plan .noTime{
  background: #facece;
}
.daysBox.holiday .plan .hasTime{
  background: #facece;
}
</style>
